/**
 * What the malware scan has said about a chat attachment (#6916). The server sends it by name.
 *
 * Only `Clean` can be downloaded. Every upload is scanned after it is stored, so a just-sent file is
 * `Pending` until the scan clears, and the server then sends its message again.
 */
export enum FileScanStatus {
  Pending = "Pending",
  Clean = "Clean",
  Infected = "Infected",
  Failed = "Failed",
}
